import script from "./ButtonPurple.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonPurple.vue?vue&type=script&setup=true&lang=js"

import "./ButtonPurple.vue?vue&type=style&index=0&id=114f27b1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114f27b1"]])

export default __exports__